import { lazy } from 'react';

import { withCampaignSavedData } from './withCampaignSavedData';

const LazyFormPagesStep02 = lazy(() =>
  import('./FormPagesStep02').then((module) => ({ default: module.FormPagesStep02 })),
);

export const EnhancedFormPagesStep02 = withCampaignSavedData(LazyFormPagesStep02);
